export default __webpack_public_path__ + "static/media/image-icon.ad37df1d.svg";